module.exports = __webpack_public_path__ + "static/img/14000080.dd1125d0.png";